const SF009_RECORD_META_KEYS = new Set([
  "formData",
  "userId",
  "createdBy",
  "createdByName",
  "importedFromTxt",
  "showInAdminTable",
  "_id",
  "__v",
  "createdAt",
  "updatedAt",
  "V1",
  "versionKey",
  "keyVersion",
]);

export function getRawSf009FormData(record) {
  if (!record || typeof record !== "object") return {};
  if (record.formData && typeof record.formData === "object" && !Array.isArray(record.formData)) {
    return { ...record.formData };
  }
  const out = {};
  for (const [key, value] of Object.entries(record)) {
    if (SF009_RECORD_META_KEYS.has(key)) continue;
    out[key] = value;
  }
  return out;
}
